import { BooleanColumn, CategoricalColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	segmentName: 'segmentName',
	bucketName: 'bucketName',
	isActive: 'isActive',
	limitBasedOffer: 'limitBasedOffer',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	code: 'code'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Segment Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.segmentName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	CategoricalColumn({
		title: 'Bucket Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.bucketName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	BooleanColumn({
		title: 'Limit Based Offer',
		mapDataToValue: (data: any) => data[COL_NAMES.limitBasedOffer],
		maxWidth: 200
	}),
	BooleanColumn({
		title: 'isActive',
		mapDataToValue: (data: any) => data[COL_NAMES.isActive],
		maxWidth: 200
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	}),
	CustomDateColumn({
		title: 'Updated At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.updatedAt
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Disabled',
		filterLabel: 'Active Coupons',
		filterValue: false
	}
];
